import { useSwrApi } from 'src/hooks/useSwrApi';

const INTERVIEW_QUESTIONS_API = `${process.env.NEXT_PUBLIC_MATCHING_URL}/resume/interview-generate-question`;

interface InterviewQuestionProps {
  questions: {
    type: string;
    question: string;
  }[];
}

// Interface
// ********************************************
interface UseSwrInterviewGenerateQuestionProps {
  locale?: Locale,
  serverSideData?: InterviewQuestionProps;
  shouldFetch?: boolean;
}


/**
 * @description SWR: fetch interview questions
 * @param locale
 * @param shouldFetch boolean, optional. Only fire the request when true (e.g. gate on auth). Default true.
 */
export const useSwrInterviewGenerateQuestion = (props: UseSwrInterviewGenerateQuestionProps) => {
  const { locale = 'ro', serverSideData, shouldFetch = true } = props;

  // SWR: fetch data
  return useSwrApi<InterviewQuestionProps>({
    url: INTERVIEW_QUESTIONS_API,
    locale,
    serverSideData,
    shouldFetch,
    apiOptions: {
      revalidateOnFocus: false,
    },
  });
};

